import React from 'react';
import ChatStatusBadge from './ChatStatusBadge';

const STATUS_COLORS = { waiting: '#f59e0b', open: '#10b981', closed: '#6b7280' };

const avatarInitials = (name) => {
    if (!name) return '?';
    const parts = name.trim().split(' ');
    return parts.length > 1
        ? `${parts[0][0]}${parts[1][0]}`.toUpperCase()
        : name[0].toUpperCase();
};

const timeAgo = (dateStr) => {
    if (!dateStr) return '';
    const diff = (Date.now() - new Date(dateStr)) / 1000;
    if (diff < 60)   return 'just now';
    if (diff < 3600) return `${Math.floor(diff/60)}m`;
    if (diff < 86400) return `${Math.floor(diff/3600)}h`;
    return `${Math.floor(diff/86400)}d`;
};

const ConversationItem = ({ conversation: conv, isSelected, onClick }) => {
    const nameStr = (conv.customerName && conv.customerMobile)
        ? `${conv.customerName} - ${conv.customerMobile}`
        : (conv.customerName || conv.customerMobile || 'Customer');
    const name    = nameStr;
    const preview = conv.lastMessage || 'No messages yet';
    const time    = timeAgo(conv.lastMessageAt || conv.createdAt);
    const unread  = conv.unreadCountAdmin || 0;

    return (
        <div
            className={`conv-item ${isSelected ? 'conv-item--selected' : ''}`}
            onClick={onClick}
        >
            <div
                className="conv-avatar"
                style={{ background: STATUS_COLORS[conv.status] || '#6b7280' }}
            >
                {avatarInitials(name)}
            </div>

            <div className="conv-item-body">
                <div className="conv-item-top">
                    <span className="conv-item-name">{name}</span>
                    <span className="conv-item-time">{time}</span>
                </div>
                <div className="conv-item-bottom">
                    <span className="conv-item-preview">
                        {conv.lastMessageType && conv.lastMessageType !== 'text'
                            ? `📎 ${conv.lastMessageType}`
                            : preview}
                    </span>
                    <div className="conv-item-meta">
                        <ChatStatusBadge status={conv.status} />
                        {unread > 0 && (
                            <span className="conv-unread-badge">{unread}</span>
                        )}
                    </div>
                </div>
                {conv.assignedAgentName && (
                    <div className="conv-agent-tag">
                        👤 {conv.assignedAgentName}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ConversationItem;
